export default __webpack_public_path__ + "static/about-illu-2-2449e663c47c327317548e752d7c653f.png";